const productData = [
  {
    id: 1,
    name: "Vanille Eau de Toilette",
    price: "68.00",
    country: "Molinard",
    reviews: "156 Reviews",
    images: ["/img/101.jpeg"],
    size: ["50ml", "100ml"],
    description: [
      "A luxurious vanilla eau de toilette that captures the warmth and sweetness of Madagascar vanilla.",
      "This sophisticated fragrance opens with soft vanilla notes, developing into a rich, creamy heart with hints of tonka bean and white musk.",
      "Perfect for daily wear, this scent offers a comforting and elegant aroma that lasts throughout the day.",
      "The vanilla essence is carefully extracted and blended to create a balanced, not-too-sweet fragrance that appeals to all ages.",
    ],
    Features: [
      "Brand: Molinard",
      "Category: Fragrance, Eau de Toilette",
      "Made in France",
      "Natural vanilla extracts from Madagascar",
      "Long-lasting formula",
      "Suitable for all skin types",
      "Elegant glass bottle design",
      "Cruelty-free and vegan-friendly",
    ],
  },
  {
    id: 2,
    name: "Badedas Classic Foam Bath",
    price: "18.50",
    country: "Badedas",
    reviews: "234 Reviews",
    images: ["/img/102.avif"],
    size: ["500ml", "1000ml"],
    description: [
      "Experience the legendary Badedas bath foam that has been a bathroom favorite since 1919.",
      "This classic formula creates rich, luxurious bubbles that transform your bath into a spa-like experience.",
      "Infused with natural horse chestnut extract, known for its soothing and revitalizing properties.",
      "The distinctive herbal fragrance awakens your senses while the gentle formula cleanses and softens your skin.",
      "Ideal for a relaxing soak after a long day or as a refreshing morning ritual.",
    ],
    Features: [
      "Brand: Badedas",
      "Category: Bath & Body, Bath Products",
      "Made in Germany",
      "Contains natural horse chestnut extract",
      "Creates rich, long-lasting foam",
      "pH-balanced formula",
      "Dermatologically tested",
      "Suitable for all skin types",
      "Classic herbal fragrance",
    ],
  },
  {
    id: 3,
    name: "Nivea Creme",
    price: "12.99",
    country: "Nivea",
    reviews: "892 Reviews",
    images: ["/img/103.avif"],
    size: ["150ml", "250ml", "400ml"],
    description: [
      "The iconic Nivea Creme in its classic blue tin - a timeless skincare essential trusted for over 100 years.",
      "This rich, nourishing cream provides intensive moisture for face, hands, and body.",
      "Formulated with Eucerit, a unique emulsifier that helps skin retain moisture and stay soft.",
      "The thick, creamy texture absorbs quickly without leaving a greasy residue.",
      "Perfect for dry skin, rough patches, and as an all-purpose moisturizer for the whole family.",
      "Can be used daily to protect and nourish skin in all weather conditions.",
    ],
    Features: [
      "Brand: Nivea",
      "Category: Skincare, Moisturizers",
      "Made in Germany",
      "Contains Eucerit emulsifier",
      "Suitable for face and body",
      "Dermatologically approved",
      "For all skin types, especially dry skin",
      "Multi-purpose cream",
      "Classic blue tin packaging",
      "Family-size available",
    ],
  },
  {
    id: 4,
    name: "Peppermint Toothpaste",
    price: "8.50",
    country: "Weleda",
    reviews: "445 Reviews",
    images: ["/img/104.avif"],
    size: ["75ml", "100ml"],
    description: [
      "Natural peppermint toothpaste that provides effective cleaning while freshening your breath.",
      "Formulated with pure peppermint essential oil for a refreshing, invigorating taste.",
      "Contains natural calcium carbonate that gently removes plaque and surface stains.",
      "Free from fluoride, SLS, synthetic preservatives, and artificial flavors.",
      "The gentle formula is suitable for sensitive teeth and gums.",
      "Leaves your mouth feeling clean and fresh with a pleasant minty aftertaste.",
    ],
    Features: [
      "Brand: Weleda",
      "Category: Oral Care, Toothpaste",
      "Made in Germany",
      "Natural peppermint essential oil",
      "Fluoride-free formula",
      "No SLS or synthetic preservatives",
      "Vegan and cruelty-free",
      "Biodegradable ingredients",
      "Suitable for sensitive teeth",
      "Gentle on enamel",
    ],
  },
  {
    id: 5,
    name: "Swedish Bitters",
    price: "24.95",
    country: "Maria Treben",
    reviews: "567 Reviews",
    images: ["/img/105.avif"],
    size: ["100ml", "200ml", "500ml"],
    description: [
      "Traditional Swedish Bitters herbal tonic based on the original Maria Treben formula.",
      "A powerful blend of 11 carefully selected herbs known for their digestive and wellness benefits.",
      "This time-honored remedy has been used for centuries to support digestion and overall wellbeing.",
      "Can be taken internally or applied externally for various wellness purposes.",
      "The bitter herbs stimulate digestive enzymes and support healthy liver function.",
      "Made according to traditional methods to preserve the potency of the herbal extracts.",
    ],
    Features: [
      "Brand: Maria Treben",
      "Category: Wellness, Herbal Remedies",
      "Made in Austria",
      "Contains 11 traditional herbs",
      "Based on original Swedish Bitters recipe",
      "Alcohol-based herbal extract",
      "Supports digestive health",
      "Can be used internally and externally",
      "Natural ingredients only",
      "Traditional preparation method",
    ],
  },
  {
    id: 6,
    name: "Full Case of Cardboard 12 Packs (120 x 20 ml)",
    price: "189.00",
    country: "Underberg",
    reviews: "178 Reviews",
    images: ["/img/106.avif"],
    size: ["120 x 20ml"],
    description: [
      "Full case of Underberg herbal digestif in convenient individual 20ml bottles.",
      "Perfect for restaurants, bars, or personal stock for those who appreciate this German classic.",
      "Each bottle contains the perfect single serving of this aromatic herbal bitter.",
      "Made from a secret blend of herbs from 43 countries, carefully selected and aged.",
      "Traditionally enjoyed after meals to aid digestion and provide a refreshing finish.",
      "The individual bottles are perfect for portion control and maintaining freshness.",
      "Ideal for gifting, entertaining, or keeping a supply on hand.",
    ],
    Features: [
      "Brand: Underberg",
      "Category: Wellness, Digestive Bitters",
      "Made in Germany",
      "120 individual 20ml bottles",
      "Secret blend of herbs from 43 countries",
      "Natural herbal ingredients",
      "Alcohol content: 44%",
      "Aids digestion",
      "Convenient single-serve format",
      "Long shelf life",
      "Bulk packaging for value",
    ],
  },
  {
    id: 7,
    name: "Miracle Mouthwash",
    price: "16.50",
    country: "Dr. Tichenor's",
    reviews: "389 Reviews",
    images: ["/img/107.avif"],
    size: ["240ml", "480ml"],
    description: [
      "Dr. Tichenor's Antiseptic Mouthwash - a powerful, concentrated formula that's been trusted since 1863.",
      "This miracle mouthwash provides superior oral hygiene with its unique blend of natural ingredients.",
      "Effectively kills germs, freshens breath, and promotes healthy gums.",
      "The concentrated formula means a little goes a long way - dilute with water for daily use.",
      "Peppermint flavor provides a refreshing, clean feeling that lasts for hours.",
      "Can also be used as a general antiseptic for minor cuts and skin irritations.",
    ],
    Features: [
      "Brand: Dr. Tichenor's",
      "Category: Oral Care, Mouthwash",
      "Made in USA",
      "Concentrated antiseptic formula",
      "Natural peppermint flavor",
      "Kills 99.9% of germs",
      "Multi-purpose antiseptic",
      "Alcohol-based formula",
      "Long-lasting freshness",
      "Trusted since 1863",
      "Can be diluted for economy",
    ],
  },
  {
    id: 8,
    name: "Cream Soap",
    price: "14.00",
    country: "4711",
    reviews: "312 Reviews",
    images: ["/img/108.avif"],
    size: ["100g", "3 x 100g"],
    description: [
      "Luxurious cream soap from the legendary 4711 Original Eau de Cologne brand.",
      "This gentle soap creates a rich, creamy lather that cleanses without drying.",
      "Infused with the classic 4711 fragrance - a refreshing blend of citrus and herbs.",
      "The moisturizing formula contains nourishing ingredients that leave skin soft and smooth.",
      "Suitable for daily use on face, hands, and body.",
      "The elegant packaging makes it perfect for display in your bathroom or as a thoughtful gift.",
    ],
    Features: [
      "Brand: 4711",
      "Category: Bath & Body, Bar Soap",
      "Made in Germany",
      "Classic 4711 fragrance",
      "Creamy, moisturizing formula",
      "Gentle on all skin types",
      "Rich, luxurious lather",
      "Citrus and herbal notes",
      "Suitable for face and body",
      "Elegant packaging",
      "Dermatologically tested",
    ],
  },
  {
    id: 9,
    name: "30 Pack (30 x 20 ml)",
    price: "52.00",
    country: "Underberg",
    reviews: "423 Reviews",
    images: ["/img/109.avif"],
    size: ["30 x 20ml"],
    description: [
      "Convenient 30-pack of Underberg herbal digestif in individual 20ml bottles.",
      "Perfect size for personal use, travel, or sharing with friends after a meal.",
      "Each bottle contains a single serving of this renowned German herbal bitter.",
      "The secret recipe includes herbs from 43 countries, aged in Slovenian oak casks.",
      "Traditionally consumed after heavy meals to support digestion and refresh the palate.",
      "The compact bottles fit easily in your pocket, purse, or travel bag.",
    ],
    Features: [
      "Brand: Underberg",
      "Category: Wellness, Digestive Bitters",
      "Made in Germany",
      "30 individual 20ml bottles",
      "Herbs from 43 countries",
      "Aged in Slovenian oak",
      "44% alcohol content",
      "Supports healthy digestion",
      "Portable single-serve format",
      "Perfect for travel",
      "Traditional German recipe",
    ],
  },
  {
    id: 10,
    name: "Whipped Shea Butter Lip Balm",
    price: "6.50",
    country: "Out of Africa",
    reviews: "678 Reviews",
    images: ["/img/1010.webp"],
    size: ["15ml"],
    description: [
      "Ultra-nourishing lip balm made with pure, unrefined shea butter whipped to perfection.",
      "This rich formula provides intense hydration and protection for dry, chapped lips.",
      "The whipped texture glides on smoothly and absorbs quickly without feeling greasy.",
      "Contains 100% pure shea butter sourced from West Africa, known for its healing properties.",
      "Natural vitamins A and E help repair and protect delicate lip skin.",
      "Unflavored and unscented, making it perfect for sensitive lips.",
      "Can also be used on cuticles, elbows, and other dry patches.",
    ],
    Features: [
      "Brand: Out of Africa",
      "Category: Lip Care, Lip Balm",
      "Made in USA",
      "100% pure unrefined shea butter",
      "Whipped for easy application",
      "Rich in vitamins A and E",
      "Unflavored and unscented",
      "Multi-purpose balm",
      "Suitable for sensitive skin",
      "Natural and organic",
      "Cruelty-free",
      "Long-lasting moisture",
    ],
  },
  {
    id: 11,
    name: "Kamill Hand Nail Creme",
    price: "8.95",
    country: "Kamill",
    reviews: "521 Reviews",
    images: ["/img/1011.avif"],
    size: ["75ml", "150ml"],
    description: [
      "Intensive hand and nail cream enriched with chamomile extract for ultimate nourishment.",
      "This German-made formula has been caring for hands since 1926.",
      "Quickly absorbs to provide deep moisture without leaving hands greasy.",
      "Chamomile extract soothes and calms irritated skin while strengthening nails.",
      "Perfect for dry, cracked hands and weak, brittle nails.",
      "The lightweight texture makes it ideal for frequent use throughout the day.",
      "Suitable for all skin types, including sensitive skin.",
    ],
    Features: [
      "Brand: Kamill",
      "Category: Hand & Nail Care",
      "Made in Germany",
      "Contains chamomile extract",
      "Fast-absorbing formula",
      "Non-greasy texture",
      "Strengthens nails",
      "Soothes dry, irritated skin",
      "Dermatologically tested",
      "Suitable for sensitive skin",
      "Trusted since 1926",
      "Compact tube for travel",
    ],
  },
  {
    id: 12,
    name: "Nivea Creme",
    price: "12.99",
    country: "Nivea",
    reviews: "892 Reviews",
    images: ["/img/1012.avif"],
    size: ["150ml", "250ml", "400ml"],
    description: [
      "The iconic Nivea Creme in its classic blue tin - a timeless skincare essential trusted for over 100 years.",
      "This rich, nourishing cream provides intensive moisture for face, hands, and body.",
      "Formulated with Eucerit, a unique emulsifier that helps skin retain moisture and stay soft.",
      "The thick, creamy texture absorbs quickly without leaving a greasy residue.",
      "Perfect for dry skin, rough patches, and as an all-purpose moisturizer for the whole family.",
      "Can be used daily to protect and nourish skin in all weather conditions.",
    ],
    Features: [
      "Brand: Nivea",
      "Category: Skincare, Moisturizers",
      "Made in Germany",
      "Contains Eucerit emulsifier",
      "Suitable for face and body",
      "Dermatologically approved",
      "For all skin types, especially dry skin",
      "Multi-purpose cream",
      "Classic blue tin packaging",
      "Family-size available",
    ],
  },
  {
    id: 13,
    name: "Rowatinex Capsules",
    price: "34.50",
    country: "Rowa Pharmaceuticals",
    reviews: "267 Reviews",
    images: ["/img/1013.avif"],
    size: ["50 capsules", "100 capsules"],
    description: [
      "Rowatinex is a natural herbal remedy designed to support urinary tract health.",
      "Contains a unique blend of essential oils including pinene, camphene, and other terpenes.",
      "These plant-based compounds work together to support kidney and urinary system function.",
      "The capsules are easy to swallow and provide consistent dosing.",
      "Traditionally used to help maintain healthy urinary flow and comfort.",
      "Made with pharmaceutical-grade essential oils for maximum efficacy and safety.",
    ],
    Features: [
      "Brand: Rowa Pharmaceuticals",
      "Category: Wellness, Urinary Health",
      "Made in Ireland",
      "Natural essential oil blend",
      "Contains pinene and camphene",
      "Supports urinary tract health",
      "Easy-to-swallow capsules",
      "Pharmaceutical grade",
      "Clinically studied formula",
      "Suitable for long-term use",
      "No artificial additives",
    ],
  },
  {
    id: 14,
    name: "Eau de Cologne Refreshing Tissues (Box of 10)",
    price: "9.50",
    country: "4711",
    reviews: "445 Reviews",
    images: ["/img/1014.avif"],
    size: ["10 tissues per box"],
    description: [
      "Refreshing cologne-scented tissues infused with the classic 4711 Original Eau de Cologne fragrance.",
      "Perfect for freshening up on-the-go, during travel, or after sports activities.",
      "Each tissue is individually wrapped for hygiene and convenience.",
      "The invigorating citrus scent provides an instant refresh and energy boost.",
      "Large, soft tissues that are gentle on skin yet effective at cleansing.",
      "Ideal for hot summer days, long flights, or anytime you need a quick refresh.",
      "Compact box fits easily in purses, bags, or car glove compartments.",
    ],
    Features: [
      "Brand: 4711",
      "Category: Personal Care, Refreshing Tissues",
      "Made in Germany",
      "Classic 4711 cologne fragrance",
      "10 individually wrapped tissues",
      "Citrus and herbal scent",
      "Large, soft tissue size",
      "Gentle on skin",
      "Perfect for travel",
      "Refreshing and invigorating",
      "Compact packaging",
      "Dermatologically tested",
    ],
  },
  {
    id: 15,
    name: "Dr. Theiss Ringelblumen Salbe (Marigold Salve)",
    price: "12.50",
    country: "Dr. Theiss",
    reviews: "634 Reviews",
    images: ["/img/1015.avif"],
    size: ["50ml", "100ml"],
    description: [
      "Traditional German marigold salve made with calendula officinalis extract.",
      "This healing ointment has been trusted for generations to soothe and repair skin.",
      "Rich in natural calendula extract known for its anti-inflammatory and healing properties.",
      "Perfect for minor cuts, scrapes, burns, dry skin, and irritations.",
      "The gentle formula is suitable for all ages, including babies and sensitive skin.",
      "Can be used on face and body to promote natural healing and skin regeneration.",
      "Non-greasy texture absorbs well while providing a protective barrier.",
    ],
    Features: [
      "Brand: Dr. Theiss",
      "Category: Skincare, Healing Salves",
      "Made in Germany",
      "Contains calendula officinalis extract",
      "Natural anti-inflammatory properties",
      "Promotes skin healing",
      "Suitable for all ages",
      "Safe for babies",
      "Multi-purpose salve",
      "Non-greasy formula",
      "Dermatologically tested",
      "Traditional German recipe",
    ],
  },
  {
    id: 16,
    name: "Amber Fragrance Roll-On",
    price: "14.00",
    country: "Kuumba Made",
    reviews: "389 Reviews",
    images: ["/img/1016.avif"],
    size: ["3.7ml", "7.4ml"],
    description: [
      "Exotic amber fragrance oil in a convenient roll-on applicator.",
      "This warm, sensual scent features rich amber notes with hints of vanilla and musk.",
      "Made with pure essential oils and natural fragrance compounds.",
      "The roll-on format allows for precise application and easy portability.",
      "Long-lasting scent that develops beautifully on your skin throughout the day.",
      "Perfect for layering or wearing alone as a signature scent.",
      "Alcohol-free formula is gentle on skin and won't dry it out.",
    ],
    Features: [
      "Brand: Kuumba Made",
      "Category: Fragrance, Roll-On Perfume",
      "Made in USA",
      "Pure amber fragrance oil",
      "Warm, sensual scent profile",
      "Convenient roll-on applicator",
      "Alcohol-free formula",
      "Long-lasting fragrance",
      "Travel-friendly size",
      "Vegan and cruelty-free",
      "Natural ingredients",
      "Unisex fragrance",
    ],
  },
  {
    id: 17,
    name: "Swedish Dream Sea Salt Soap",
    price: "7.50",
    country: "Swedish Dream",
    reviews: "756 Reviews",
    images: ["/img/1017.avif"],
    size: ["130g"],
    description: [
      "Luxurious sea salt soap inspired by the pristine waters of the Swedish archipelago.",
      "Infused with mineral-rich sea salt that gently exfoliates and purifies skin.",
      "The fresh, clean scent evokes the crisp ocean air and coastal landscapes.",
      "Creates a rich, creamy lather that cleanses without stripping natural oils.",
      "Sea minerals help detoxify and revitalize tired, dull skin.",
      "The triple-milled formula ensures a long-lasting bar that won't become mushy.",
      "Suitable for all skin types, especially beneficial for oily or acne-prone skin.",
    ],
    Features: [
      "Brand: Swedish Dream",
      "Category: Bath & Body, Bar Soap",
      "Made in Sweden",
      "Contains mineral-rich sea salt",
      "Gentle exfoliating properties",
      "Fresh ocean scent",
      "Triple-milled for longevity",
      "Rich, creamy lather",
      "Suitable for all skin types",
      "Detoxifying and purifying",
      "Vegan formula",
      "Cruelty-free",
    ],
  },
  {
    id: 18,
    name: "Cardboard 12 Pack (12 x 20 ml)",
    price: "22.00",
    country: "Underberg",
    reviews: "298 Reviews",
    images: ["/img/1018.avif"],
    size: ["12 x 20ml"],
    description: [
      "Classic 12-pack of Underberg herbal digestif in individual 20ml bottles.",
      "The perfect introduction to this legendary German herbal bitter.",
      "Each bottle contains a single serving, making it easy to enjoy after meals.",
      "Made from a secret recipe of herbs from 43 countries, matured in oak casks.",
      "The distinctive bitter taste is followed by a pleasant herbal aftertaste.",
      "Traditionally served at room temperature in its iconic single-serve bottle.",
      "Great for gifting or keeping on hand for after-dinner digestive support.",
    ],
    Features: [
      "Brand: Underberg",
      "Category: Wellness, Digestive Bitters",
      "Made in Germany",
      "12 individual 20ml bottles",
      "Secret herbal blend from 43 countries",
      "Matured in oak casks",
      "44% alcohol content",
      "Aids digestion naturally",
      "Single-serve convenience",
      "Perfect gift size",
      "Traditional German recipe since 1846",
      "Iconic packaging",
    ],
  },
  {
    id: 19,
    name: "Agiolax Granules",
    price: "28.50",
    country: "Madaus",
    reviews: "412 Reviews",
    images: ["/img/1019.avif"],
    size: ["250g", "500g"],
    description: [
      "Natural herbal laxative granules made from senna leaves and psyllium seeds.",
      "Provides gentle, reliable relief from occasional constipation.",
      "The combination of senna and psyllium works synergistically for effective results.",
      "Granules can be taken directly or mixed with water, juice, or yogurt.",
      "Works overnight to promote natural, comfortable bowel movements.",
      "Made with high-quality herbal ingredients according to traditional formulations.",
      "Suitable for adults seeking a natural approach to digestive regularity.",
    ],
    Features: [
      "Brand: Madaus",
      "Category: Wellness, Digestive Health",
      "Made in Germany",
      "Contains senna leaves and psyllium",
      "Natural herbal laxative",
      "Gentle, overnight relief",
      "Easy-to-take granules",
      "Can be mixed with beverages",
      "Traditional herbal formula",
      "Effective for occasional constipation",
      "High-quality ingredients",
      "Trusted European brand",
    ],
  },
  {
    id: 20,
    name: "Bronchialtee # 8 Bags",
    price: "9.95",
    country: "Salus",
    reviews: "523 Reviews",
    images: ["/img/1020.avif"],
    size: ["15 tea bags"],
    description: [
      "Traditional German herbal tea blend specifically formulated to support respiratory health.",
      "Contains a carefully selected mix of herbs including thyme, fennel, and licorice root.",
      "These herbs have been traditionally used to soothe throats and support bronchial wellness.",
      "The warming, aromatic tea provides comfort during cold seasons or when feeling under the weather.",
      "Each tea bag is individually wrapped to preserve freshness and potency.",
      "Can be enjoyed throughout the day, sweetened with honey if desired.",
      "Made by Salus, a trusted name in herbal remedies since 1916.",
    ],
    Features: [
      "Brand: Salus",
      "Category: Wellness, Herbal Tea",
      "Made in Germany",
      "Contains thyme, fennel, and licorice root",
      "Supports respiratory health",
      "Soothes throat and bronchial passages",
      "15 individually wrapped tea bags",
      "Caffeine-free",
      "Natural herbal ingredients",
      "Traditional German formula",
      "Can be sweetened with honey",
      "Trusted since 1916",
    ],
  },
];

export default productData;
